import { Button, Card, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Dashboard = () => {
  const activeRole = useSelector((state) => state?.menu?.role);

  const adminRoles = ['admin', 'super-admin'];

  return (
    <Row className="mt-2">
      {[...adminRoles].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Cash Collection
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Collection/Centers/Branches and more.</Card.Text>
              <Button size="sm" href="#/entries" variant="outline-danger">
                Go to entries
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'store-operator'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Bill Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Electricity, Water, Tele/Wi-Fi Bills.</Card.Text>
              <Button size="sm" href="#/bill-details" variant="outline-danger">
                Go to Bill Details
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'fixed-asset-manager', 'fixed-asset-admin'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Fixed Assets
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Assets/GRNs/Disposals and more.</Card.Text>
              <Button size="sm" href="#/grn" variant="outline-danger">
                Go to GRN
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'coupon-admin'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Manage Coupons
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Coupons-Companies/Coupons and more.</Card.Text>
              <Button size="sm" href="#/cs/coupons" variant="outline-danger">
                Go to Coupons
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'vehicle-manager'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Vehicle Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Vehicles Requests, Orders & Running vehicles.</Card.Text>
              <Button size="sm" href="#/vm/dashboard" variant="outline-danger">
                Go to VMS Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'machine-manager', 'machine-admin'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Machine Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Machine Requests, Purchase Orders & Installations.</Card.Text>
              <Button size="sm" href="#/mm/dashboard" variant="outline-danger">
                Go to MMS Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'cake-manager', 'cake-admin'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Cake Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Cake Categories, Shapes, Flavours, Products and Orders.</Card.Text>
              <Button size="sm" href="#/cake/orders" variant="outline-danger">
                Go to Orders
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'inventory-admin', 'inventory-manager'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Inventory Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text>Manage Indents, GRNs & Purchase orders.</Card.Text>
              <Button size="sm" href="#/inv/indents" variant="outline-danger">
                Go to Indents
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'agreement-admin'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Building Agreements
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Agreements & Rental Increments.</Card.Text>
              <Button size="sm" href="#/agr/dashboard" variant="outline-danger">
                Go to Agreements Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {['super-admin', 'festival-admin', 'festival-manager'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              Festival Management
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Festival, Festival Dates, Products and more.</Card.Text>
              <Button size="sm" href="#/fest/festivals" variant="outline-danger">
                Go to Festivals
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
      {[...adminRoles, 'ads-manager'].includes(activeRole) && (
        <Col xs={3} className="mb-3">
          <Card
            className="h-100 d-flex flex-column"
            style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
          >
            <Card.Header
              style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}
            >
              KS ADS
            </Card.Header>
            <Card.Body className="flex-grow-1" style={{ fontSize: '14px', color: '#666666', padding: '20px' }}>
              <Card.Text className="equal-height-p">Manage Advertisement</Card.Text>
              <Button size="sm" href="#/ks-ads/home" variant="outline-danger">
                Go to Ks Ads
              </Button>
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default Dashboard;
